import { useQuery } from '@tanstack/react-query';
import { useUserCity } from '../../../Common/hooks/useUserCity';
import Toast from '../../../../../../core/components/core/Util/Toast/Toast';
import Fetch from '../../../../../util/core/Fetch';
import config from '../../../../../config/config';
import { getUserSession } from '../../../../../util/core/Session';

export const useChartsData = (queryConfig, filters) => {
    const { data, isLoading } = useUserCity();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const isClientManager =
        profile === config.default_foreign_key.sdg_profiles.clientManager;

    if (
        !data?.governance_room_geo_city_id &&
        !isLoading &&
        !isAdm &&
        !isClientManager
    ) {
        Toast.error('Erro ao carregar cidade do usuário');
    }

    const enabled =
        !isAdm && !isClientManager
            ? !!data?.governance_room_geo_city_id
            : !!filters.city;

    return useQuery({
        queryKey: [queryConfig.key, ...Object.values(filters)],
        queryFn: async ({ signal }) => {
            const city =
                !isAdm && !isClientManager
                    ? data?.governance_room_geo_city_id
                    : filters?.city;
                    
            const requestFilters = {
                filters: {
                    mes_competencia: filters.month,
                    ano_competencia: filters.year,
                    governance_room_geo_city_id: city,
                    co_seq_dim_unidade_saude: filters.location,
                    register_type: filters.register_type,
                    service_type_id: filters.service_type,
                    house_hold_status: filters.household_status,
                    co_imunobiologico: filters.immunobiologicals,
                    co_dose_imunobiologico: filters.immunobiologicals_doses,
                    procedure_id: filters.procedures,
                    group_id: filters.procedure_group,
                    sub_group_id: filters.procedure_subgroup,
                    cbo_id: filters.cbo
                }
            };

            return await Fetch.post(
                config.endpoints.backend + queryConfig.url,
                requestFilters,
                signal
            );
        },
        enabled: !!filters.year && !isLoading && enabled,
        staleTime: 1000 * 60 * 60
    });
};

const GENERAL_RESULTS_GENERAL_RESULTS_ESUS =
    'general-results-general-results-sih';
const GENERAL_RESULTS_SCHEDULING_ESUS = 'general-results-scheduling-esus';
const REGISTERS_RESULTS_ESUS = 'registers-results-esus';
const REGISTERS_REGISTERS_ESUS = 'registers-registers-esus';
const REGISTERS_MAPPING_ESUS = 'registers-mapping-esus';
const PRODUCTION_SUMMARY_ESUS = 'production-summary-esus';
const PRODUCTION_GENERAL_PRODUCTION_ESUS = 'production-general-production-esus';
const PRODUCTION_STRATIFIED_PRODUCTION_ESUS =
    'production-stratified-production-esus';
const PRODUCTION_HOUSEHOLD_VISIT_ESUS = 'production-household-visit-esus';
const PRODUCTION_VACCINATION_ESUS = 'production-vaccination-esus';
const PRODUCTION_PROCEDURES_ESUS = 'production-procedures-esus';
const PRODUCTION_PROFESSIONALS_ESUS = 'production-professionals-esus';
const PRODUCTION_MAPPING_ESUS = 'production-mapping-esus';

export const QUERY_KEYS_ESUS = {
    GENERAL_RESULTS_GENERAL_RESULTS: GENERAL_RESULTS_GENERAL_RESULTS_ESUS,
    GENERAL_RESULTS_SCHEDULING: GENERAL_RESULTS_SCHEDULING_ESUS,
    REGISTERS_RESULTS: REGISTERS_RESULTS_ESUS,
    REGISTERS_REGISTERS: REGISTERS_REGISTERS_ESUS,
    REGISTERS_MAPPING: REGISTERS_MAPPING_ESUS,
    PRODUCTION_SUMMARY: PRODUCTION_SUMMARY_ESUS,
    PRODUCTION_GENERAL_PRODUCTION: PRODUCTION_GENERAL_PRODUCTION_ESUS,
    PRODUCTION_HOUSEHOLD_VISIT: PRODUCTION_HOUSEHOLD_VISIT_ESUS,
    PRODUCTION_STRATIFIED_PRODUCTION: PRODUCTION_STRATIFIED_PRODUCTION_ESUS,
    PRODUCTION_VACCINATION: PRODUCTION_VACCINATION_ESUS,
    PRODUCTION_PROCEDURES: PRODUCTION_PROCEDURES_ESUS,
    PRODUCTION_PROFESSIONALS: PRODUCTION_PROFESSIONALS_ESUS,
    PRODUCTION_MAPPING: PRODUCTION_MAPPING_ESUS
};
